module.exports = __webpack_public_path__ + "static/media/kemi.8292b528.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kemi.jpeg
// module id = 44
// module chunks = 0